<template>
  <b-modal
    title="Vincular o atributo ao produto"
    no-close-on-backdrop
    size="lg"
    ok-only
    centered
    hide-footer
    header-bg-variant="orange"
    header-text-variant="light"
    v-model="open"
    :busy="loading"
  >
    <b-row class="container">
      <b-col cols="12" class="my-2 text-center">
        <h5>Escolha abaixo os atributos que deseja vincular ao produto</h5>
      </b-col>
      <b-col v-if="optionsAttribute.length > 0" cols="12" md="6" class="my-4">
        <label>Selecione o atributo pai</label>
        <b-form-select 
          v-model="selectedAttribute" 
          :options="optionsAttribute" 
          @change="getValueAttribute()"
          size="sm"  
        />
      </b-col>
      <b-col v-if="optionsAttribute.length > 0" cols="12" md="6" class="my-4">
        <label>Selecione o atributo filho</label>
        <b-form-select 
          v-model="selectedValueAttribute" 
          :options="optionsValueAttribute" 
          size="sm" 
        />
      </b-col>
      <b-col v-if="optionsAttribute.length == 0" cols="12" class="my-3">
        <h6 class="text-center">Este produto já está vinculado a todos os atributos</h6>
      </b-col>
      <b-col v-if="hasAttribute"  cols="12" class="mt-2 mb-4">
        <h4 class="text-center">Atributos já Selecionado</h4>
        <b-table
          striped
          outlined
          hover
          responsive
          :fields="table.headers"
          :items="table.records"
          class="mt-4"
        >
          <template #cell(action)="data">
            <b-button
              @click="deleteProduct(data.item.id)"
              variant="danger"
              title="Exluir o atributo"
              size="sm"
              class="ml-4"
            >
              <i class="fas fa-trash"></i>
            </b-button>
          </template>
        </b-table>
      </b-col>
      <b-col cols="12" md="6" class="mt-4">
        <b-button @click="close()" variant="danger" block>
          Cancelar
        </b-button>
      </b-col>
      <b-col cols="12" md="6" class="mt-4">
        <b-button @click="save()" variant="success" block>
          Salvar
        </b-button>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import makeToast from '@/mixins/makeToast';
export default {
  name: 'SelectAttributesModal',
  mixins: [makeToast],
  emits: ['getVariation'],
  
  props : {
    productVariationSelected: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      loading: false,
      open: false,
      selectedAttribute: null,
      selectedValueAttribute: null,
      shopkeeperId: null,
      productId: null,
      productChildId: null,
      optionsAttribute: [],
      optionsValueAttribute: [],
      valuesAttribute: [],
      hasAttribute: false,
      table:{
        headers: [
          {
            key: 'id',
            thClass: 'd-none',
            tdClass: 'd-none',
          },
          {
            key: 'attribute',
            label: 'Atributo Pai',
          },
          {
            key: 'attributeChild',
            label: 'Atributo Filho',
          },
          {
          key: 'action',
          label: 'Ação',
          },
        ],
        records:[]
      },
    };
  },

  methods: {
    toggleOpen({ shopkeeperId = null, productId = null, productChildId = null }) {
      this.open = !this.open;
      this.clean()
      this.shopkeeperId = shopkeeperId;
      this.productId = productId;
      this.productChildId = productChildId;
      this.getAttribute();
    },
    save() {
      if(!this.selectedAttribute || !this.selectedValueAttribute) {
        this.makeToast(
          'Erro',
          'Selecione o atributo e o valor do atributo',
        );
        return;
      }

      const data = {
        product_parent_id: this.productId,
        product_child_id: this.productChildId,
        construp_user_id: this.shopkeeperId,
        attributes: [this.selectedValueAttribute]
      };

      this.loading = true;
      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/addProductAttribute', data)
        .then((response) => {
          if(!response.data.error) {
            this.makeToast(
              'Sucesso',
              'Produto vinculado com sucesso',
            );
            this.$emit('getVariation');
            this.close();
            return
          }
          
          this.makeToast(
            'Erro',
            `Houve um erro ao salvar os dados`,
            'danger'
          );
        })
        .catch((error) => {
          this.makeToast(
            'Erro',
            `Houve um erro ao salvar os dados`,
            'danger'
          );
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    getAttribute() {
      this.optionsAttribute = [];
      
      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/getAttributeProduct', this.shopkeeperId)
        .then((response) => {
          const result = response.data.data.data;

          result.forEach((item) => {
            this.optionsAttribute.push({
              value: item.id,
              text: item.name,
            });

            if (item.values_attribute || item.values_attribute.length > 0) {
              item.values_attribute.forEach((childAttr) => {
                this.valuesAttribute.push(childAttr);
              });
            }
          });
        })
        .catch((error) => {
          this.makeToast(
            'Erro',
            `Houve um erro ao buscar os dados`,
          );
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
          this.getInfoAttibute()
        });
    },
    getValueAttribute() {
      this.optionsValueAttribute = [];
      this.selectedValueAttribute = null;

      this.valuesAttribute.forEach((childAttr) => {
        if(childAttr.attribute_variation_id == this.selectedAttribute) {
          
          const exist = this.optionsValueAttribute.some((item) => item.value == childAttr.id);
          
          if(!exist) {
            this.optionsValueAttribute.push({
              value: childAttr.id,
              text: childAttr.value,
            });
          }
        }
      });      
    },
    getInfoAttibute() {
      this.table.records = [];
      this.hasAttribute = false;
      const option = this.optionsAttribute;

      this.productVariationSelected.map((item) => {
        if(item.product_parent_id == this.productChildId || item.product_child_id == this.productChildId) {
          this.hasAttribute = true;
          
          item.product_attribute.forEach(element => {
            option.map((attribute, index) => {
              const idAttribute =  element.value_attribute.attribute_variation_id
           
              if(attribute.value == idAttribute) {
                this.optionsAttribute.splice(index, 1);
                
                this.table.records.push({
                  attribute: attribute.text,
                  attributeChild: element.value_attribute.value,
                  id: item.id,
                });
              }
            })
          });
        }
      });
    },
    deleteProduct(id) {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/deleteProductAttribute', id)
      .then((resp) => {
        this.makeToast(
          'Sucesso',
          'Apagado com sucesso!',
          'success'
        );
        this.$emit('getVariation');
        this.optionsValueAttribute = [];
        this.selectedValueAttribute = null;
        this.getAttribute();
      })
      .catch(() => {
        this.makeToast(
          'Erro',
          'Houve um erro ao excluir produto do serviço!',
          'danger'
        );
      })
      .finally(() => {
        this.$store.dispatch('endLoader');
      });
    },
    close() {
      this.clean();
      this.open = !this.open;
    },
    clean() {
      this.productId = null;
      this.productChildId = null;
      this.selectedAttribute = null;
      this.selectedValueAttribute = null;
      this.optionsAttribute = [];
      this.optionsValueAttribute = [];
      this.valuesAttribute = [];
      this.table.records = [];
      this.hasAttribute = false;
    },
  },
};
</script>